import { createContext, useContext } from 'react'

import type { RouterAdapter } from './types'

const RouterAdapterContext = createContext<RouterAdapter | null>(null)

export const RouterAdapterProvider = RouterAdapterContext.Provider

export function useRouterAdapter(): RouterAdapter {
  const adapter = useContext(RouterAdapterContext)
  if (!adapter) {
    throw new Error('useRouterAdapter must be used within a RouterAdapterProvider')
  }
  return adapter
}
